import { CTAButton } from "@/components/ui/cta-button";

interface DiscoverSectionProps {
  onShowWaitlist: () => void;
}

export const DiscoverSection = ({ onShowWaitlist }: DiscoverSectionProps) => {
  return (
    <section className="py-16 w-full bg-gradient-to-b from-white to-gray-50 overflow-x-hidden">
      <div className="container max-w-4xl mx-auto text-center space-y-6 px-4">
        <h2 className="text-3xl sm:text-4xl font-mono font-bold text-primary">
          Prêt à découvrir l'Aisne autrement ?
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Des expériences uniques, des lieux secrets et des histoires à raconter vous attendent.
        </p>
        <CTAButton
          onClick={onShowWaitlist}
          desktopText="Découvrir les secrets de l'Aisne 🎯"
        />
      </div>
    </section>
  );
};